"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataOperationType = void 0;
const baseEvent_1 = require("./baseEvent");
const uuid_1 = require("uuid");
const zod_extensions_1 = require("@reachmedianetwork/zod-extensions");
/**
 * Data operation types that can be observed.
 * Values are abbreviated to save space when serialized.
 */
var DataOperationType;
(function (DataOperationType) {
    DataOperationType["Insert"] = "ins";
    DataOperationType["Update"] = "upd";
    DataOperationType["Delete"] = "del";
})(DataOperationType = exports.DataOperationType || (exports.DataOperationType = {}));
const DataEventSchema = zod_extensions_1.z.object({
    type: zod_extensions_1.z.literal('data'),
    op: zod_extensions_1.z.nativeEnum(DataOperationType),
    name: zod_extensions_1.z.string(),
    key: zod_extensions_1.z.string(),
    actor: zod_extensions_1.z.string().optional(),
    id: zod_extensions_1.z.string(),
    time: zod_extensions_1.z.unknown().marshalTo('integer'),
    eid: zod_extensions_1.z.string().optional(),
    customData: zod_extensions_1.z.unknown().optional(),
});
/**
 * Events representing operations on higher order objects of concern to certain
 * consumers
 *
 * @remarks
 *
 * For example: A data list cell may be updated resulting in a {@link DalEvent}
 * for that cell, but a player subscribes to events related to data lists so we
 * would emit a {@link DataEvent}
 */
class DataEvent extends baseEvent_1.default {
    constructor() {
        super(...arguments);
        this.type = 'data';
    }
    static create(op, name, key, actor, eid, customData) {
        const event = new DataEvent(uuid_1.v4(), Date.now(), eid);
        event._op = op;
        event._name = name;
        event._key = key;
        event._actor = actor;
        event._customData = customData;
        return event;
    }
    /**
     * The specific operation that was performed.
     */
    get op() {
        return this._op;
    }
    /**
     * The data type the operation was performed on (e.g. weather)
     */
    get name() {
        return this._name;
    }
    /**
     * Primary identifier of the data source (e.g. weather zip code)
     */
    get key() {
        return this._key;
    }
    /**
     * the actor who is responsible for this data change.
     */
    get actor() {
        return this._actor;
    }
    /**
     * custom data for this data event.
     */
    get customData() {
        return this._customData;
    }
    parse(record) {
        const parsedRecord = DataEventSchema.parse(record);
        const event = new DataEvent(parsedRecord.id, parsedRecord.time, parsedRecord.eid);
        event._op = parsedRecord.op;
        event._name = parsedRecord.name;
        event._key = parsedRecord.key;
        event._actor = parsedRecord.actor;
        event._customData = parsedRecord.customData;
        return event;
    }
}
exports.default = DataEvent;
//# sourceMappingURL=dataEvent.js.map